import { useMemo } from "react";

import { AppConfig } from "~/AppConfig";
import { useImpersonation } from "~/hooks/useImpersonation";
import { SegmentHelmet } from "~/tracking/segment";

export function useSegmentScript() {
  const { isImpersonating } = useImpersonation();

  const segmentHelmet = useMemo(
    () =>
      !isImpersonating && Boolean(AppConfig.SEGMENT_WRITE_KEY) ? (
        <SegmentHelmet />
      ) : null,
    [isImpersonating],
  );

  return { segmentHelmet };
}
